interface EvaluationInfoProps {
    evaluator: string;
    evaluatee: string;
    dueDate: string;
    completionDate: string;
    status: string;
    isAnonymous: string;
}

export default function EvaluationInfo({ evaluator, evaluatee, dueDate, completionDate, status, isAnonymous }: EvaluationInfoProps) {
    return (
        <div className="evaluation-info">
            <h3 className="evaluation-info__title">Evaluation Info</h3>
            <div className="evaluation-info__grid">
                <div className="evaluation-info__row">
                    <div className="evaluation-info__item">
                        <span className="evaluation-info__label">Evaluator</span>
                        <span className="evaluation-info__separator">/</span>
                        <span className="evaluation-info__value">{evaluator}</span>
                    </div>
                    <div className="evaluation-info__item">
                        <span className="evaluation-info__label">Due Date</span>
                        <span className="evaluation-info__separator">/</span>
                        <span className="evaluation-info__value">{dueDate}</span>
                    </div>
                    <div className="evaluation-info__item">
                        <span className="evaluation-info__label">Status</span>
                        <span className="evaluation-info__separator">/</span>
                        <span className="evaluation-info__value">{status}</span>
                    </div>
                </div>
                <div className="evaluation-info__row">
                    <div className="evaluation-info__item">
                        <span className="evaluation-info__label">Evaluatee</span>
                        <span className="evaluation-info__separator">/</span>
                        <span className="evaluation-info__value">{evaluatee}</span>
                    </div>
                    <div className="evaluation-info__item">
                        <span className="evaluation-info__label">Completion Date</span>
                        <span className="evaluation-info__separator">/</span>
                        <span className="evaluation-info__value">{completionDate}</span>
                    </div>
                    <div className="evaluation-info__item">
                        <span className="evaluation-info__label">Anonymous</span>
                        <span className="evaluation-info__separator">/</span>
                        <span className="evaluation-info__value">{isAnonymous}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
